export default __webpack_public_path__ + "static/media/expand-alt.54f56127.svg";